import React from "react"
import FieldNumber from "../../number/number"
import FieldCurrency_ManagementPreview from "./render/management-preview"
import FieldConfig from "../../../proto/field-config"
import {GROUP_NUMBER} from "../../../../gd/const/fields/field2-groups"
import FieldCurrency_ManagementForm from "./render/management-form"
import normalizeNumber from "../../../import/normalize/normalize-number"
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldCurrency_Editable from "./render/editable/editable"
import {FieldFilterType} from "../../../proto/types"
import {
    ConditionType_IsNull,
    ConditionType_NotNull,
    ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan, ConditionType_NumberLessThan
} from "../../../../model2/conditions/condition-types"
import FieldCurrency_ConditionForm from "./render/condition"

export default class FieldCurrency extends FieldNumber {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Currency";
        this.typeGroup          = GROUP_NUMBER;
        this.typeDescription    = "Currency input field";
        this.filterType         = FieldFilterType.NUMBER;
        this.icon               = 'i5-money';

        // special
        const currency          = gd.company.financeCurrency || 'us_dollar'

        this.symbolId           = _.get(config,'symbolId',currency)
        this.decimalPlaces      = _.get(config,'decimalPlaces',2)
        this.positiveOnly       = _.get(config,'positiveOnly',false)
        this.integersOnly       = _.get(config,'integersOnly',false)

        this.conditionTypes     = [
            ConditionType_NotNull,
            ConditionType_IsNull,
            ConditionType_NumberGreaterThan,
            ConditionType_NumberLessThan,
            ConditionType_NumberEquals
        ]

        _.assign(this.components,{
            // @ts-ignore
            ValuePrefix: <span className="ui5-txt-not-important m-r-5 fl-no-shrink">{gd.const.currency[this.symbolId].symbol}</span>
        })

        _.assign(this.renderComponents,{

        })

        this.renderComponents.managementPreview = FieldCurrency_ManagementPreview
        this.renderComponents.managementForm    = FieldCurrency_ManagementForm

        this.renderComponents.editable          = FieldCurrency_Editable
        this.renderComponents.conditionForm     = FieldCurrency_ConditionForm
    }

    /*** DISPLAY VALUE FUNCTIONS [INPUT ONLY] ***/

    getDisplayValue(value:any) {
        if (isNaN(value)) return value;

        let res = value;

        if (this.isValueValid(value)) {
            switch (typeof value) {
                case 'number':  res = value; break;
                default:        res = parseFloat(value); break;
            }
        }

        return isNaN(res) ? null : res.toLocaleString('en', {
            useGrouping:true,
            minimumFractionDigits: this.decimalPlaces,
            maximumFractionDigits: this.decimalPlaces
        });
    }

    // /*** Management Render methods ***/
    //
    // renderManagementForm(onSubmit, isNewField) {
    //     return <FieldCurrencyManagementForm field={this} onSubmit={onSubmit} isNew={isNewField}/>;
    // }

    // renderManagementPreview() {
    //     return <FieldString_View field={this} value={1500.45}/>;
    // }

    /*** IMPORT EXPORT ***/

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        return this.getDisplayValue(rawValue)
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeNumber(value)
    }

    toJson() {
        let result = super.toJson()
        result.symbolId         = this.symbolId
        result.decimalPlaces    = this.decimalPlaces
        result.positiveOnly     = this.positiveOnly
        result.integersOnly     = this.integersOnly
        return result
    }
}
